import React, {Component} from 'react';
import {connect} from 'react-redux';
import validate from 'validate.js';

import * as spActions from '../../actions/sp';
import AppNames from "../AppNames/AppNames";
import '../index.scss';
import {checkSession} from "../../api/api";
import * as messageConstants from '../../shared/messages';
import Message from "../Message";
import {
    MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import {WS_FEDERATION_APPLICATION} from "../../constants/applicationTypes.js";
import RedirectUri from "./RedirectUri/RedirectUri";
import WsFederationIdpMetadataPopup from "./WsFederationIdpMetadataPopup/WsFederationIdpMetadataPopup"
import * as idpActions from "../../actions/idp";
import IdpCertificateMessage from "../AddSAML/CertificateExpirationBanner/IdpCertificateMessage";
import {getMappedCapabilities} from "../../actions/storage";
import Moment from "moment";
import * as consts from "../../constants/idpAdminConstants";
import StartUsingNewIdpCertificateModal from "../AddSAML/NewIdPCertificate/StartUsingNewIdpCertificateModal";
import NewIdpCertificatePanel from "../AddSAML/NewIdPCertificate/NewIdpCertificatePanel";

export class WsFederationApp extends Component {

    handleFrameTasks = (e) => {
        console.log(e);
    }

    handleSaveSP = () => {
        let wsFederationProfile =  this.props.wsFederationProfile;
        wsFederationProfile.redirectUri = this.props.redirectUri;

        const newMeta = {
            name: this.props.applicationName,
            userFriendlyName: this.props.userFriendlyName,
            applicationType: WS_FEDERATION_APPLICATION,
            wsFederationProfile: wsFederationProfile,
            applicationId: this.props.applicationId
        }

        const constraints = {
            name: {
                presence: {
                    allowEmpty: false,
                    message: messageConstants.SBA_WARNING_BLANK_APPNAME
                }
            },
            userFriendlyName: {
                presence: {
                    allowEmpty: false,
                    message: messageConstants.SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME
                }
            },
            wsFederationProfile: {
                presence: {
                    allowEmpty: false,
                    message: messageConstants.SBA_WARNING_BLANK_METADATA
                }
            },
        };
        const errors = validate(newMeta, constraints, {fullMessages: false});

        if (errors) {
            this.setState({errors});
            this.props.setErrorMessage(errors[Object.keys(errors)[0]]);
        } else {
            if (this.props.applicationId) {
                this.props.updateApp(newMeta);
            } else {
                this.props.addApp(newMeta);
            }
        }
    }

    handleAddWsFedCancel = () => {
        this.props.cancelAddApp();
    }

    handleEditApplication = () => {
        if (this.props.match.params.applicationId) {
            this.props.editAppId(this.props.match.params.applicationId);
            this.handleGetIdpMetadata(this.props.match.params.applicationId);
        }
    }

    handleChangeAppName = (e) => {
        this.props.updateAppName(e.target.value);
    }
    handleChangeUserFriendlyName = (e) => {
        this.props.updateUserFriendlyName(e.target.value)
    }

    handleUserFriendlyNameBlur = () => {
        if (!this.props.userFriendlyName.length > 0) {
            this.props.updateUserFriendlyName(this.props.applicationName)
        }
    }

    handleGetIdpMetadata = (applicationId) => {
        this.props.getIdpMetadata(applicationId);
    }
    handleShowModalWsFedIdpMetadata = () => {
        this.props.showWsFedIdpMetadataPopup();
    }
    handleHideModalWsFedIdpMetadata = () => {
        this.props.hideWsFedIdpMetadataPopup();
    }
    handleOpenHelpDocPage = (url) => {
        this.props.openHelpDocPage(url);
    }
    getIdpCertificateExpirationMessageType = () => {
        let messageType = null;
        if (this.props.idpCertificateValidTo && this.props.applicationId) {
            let currentDate = new Moment();
            let idpTransitionPeriodStart = this.props.idpCertificateValidTo.clone().subtract(consts.transitionPeriodForIdpCertificate, "days");
            let lastCertificateRotationDate = this.props.lastCertificateRotationDate;

            if ((currentDate.isAfter(idpTransitionPeriodStart) && !this.props.lastCertificateRotationDate)
                || (currentDate.isAfter(idpTransitionPeriodStart) && lastCertificateRotationDate.isBefore(idpTransitionPeriodStart))) {

                messageType = "Info";
            } else {
                messageType = "Success";
            }
        }
        return messageType;
    }
    handleStartUsingNewIdpCertificate = () => {
        this.props.startUsingNewIdpCertificate(this.props.applicationId)
    }
    componentDidMount() {
        if (checkSession(this.props.history)) {
            window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
            this.handleEditApplication();
        }
    }

    componentWillUnmount() {
        window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.applicationId && this.props.applicationId) {
            this.handleGetIdpMetadata(this.props.applicationId);
        }
        if (!prevProps.wsFedIssuerUrl && this.props.wsFedIssuerUrl) {
            this.handleShowModalWsFedIdpMetadata()
        }
    }

    render() {
        const capabilities = JSON.parse(getMappedCapabilities());
        const {applicationName, userFriendlyName, redirectUri, applicationId} = this.props;
        return (
            <div className="AddApp-container">
                <div className="container">
                    <Message successMessage={this.props.successMsg}
                             errorMessage={this.props.errorMsg}
                             clearMessages={this.props.clearMessages}/>
                    <IdpCertificateMessage capabilities={capabilities}
                                           applicationId={this.props.applicationId}
                                           messageType={this.getIdpCertificateExpirationMessageType()}
                                           expirationDate={this.props.idpCertificateValidTo}
                                           newExpirationDate={this.props.newIdpCertificateValidTo}
                                           handleOpenHelpDocPage={this.handleOpenHelpDocPage}/>

                    <div className="row">
                        <div className="col-xs-12 col-sm-8 col-md-8">
                            <div className="add-edit-title">{applicationId
                                ? messageConstants.WS_FED_TITLE_EDIT
                                : messageConstants.WS_FED_TITLE_ADD}</div>
                            <div className="add-edit-subtitle">
                                {messageConstants.WS_FED_SUBTITLE}
                            </div>

                            <AppNames applicationName={applicationName}
                                      userFriendlyName={userFriendlyName}
                                      handleChangeAppName={this.handleChangeAppName}
                                      handleChangeUserFriendlyName={this.handleChangeUserFriendlyName}
                                      handleUserFriendlyNameBlur={this.handleUserFriendlyNameBlur}/>

                            <RedirectUri
                                redirectUri={redirectUri}
                                handleUpdateWsFedRedirectUri={this.props.updateWsFedRedirectUri}
                                handleOpenHelpDocPage={this.handleOpenHelpDocPage}/>
                            &nbsp;
                            <div>
                                <h3 className="sba-subtitle">{messageConstants.SBA_METADATA_REQUIRED_SP}</h3>
                                <div className="add-edit-subtitle">
                                    {messageConstants.SBA_WS_FED_METADATA_REQUIRED_SP_DESCRIPTION}
                                </div>
                                {
                                    (this.props.applicationId && this.getIdpCertificateExpirationMessageType() === "Info") ? (
                                        <NewIdpCertificatePanel
                                            newIdpMetadataButtonText={messageConstants.NEW_WS_FED_IDP_METADATA_VIEW_AND_COPY_BUTTON}
                                            showIdpMetadataPopup={this.handleShowModalWsFedIdpMetadata}
                                            showStartUsingNewIdpCertificatePopup={this.props.showModalStartUsingNewIdpCertificate}
                                        />
                                    ) : (
                                        <div className="view-idp-metadata-block">
                                            {applicationId && this.props.idpMetadata.wsFedIssuerUrl ? (
                                                <button id="showModalWsFedIdpMetadataButton"
                                                    className="btn btn-link view-idp-metadata-button"
                                                    onClick={this.handleShowModalWsFedIdpMetadata}
                                                >
                                                    {messageConstants.WS_FED_IDP_VIEW_AND_COPY_METADATA}
                                                </button>
                                            ) : (
                                                <button
                                                    id="generateWsFedMetadataButton"
                                                    type="button"
                                                    className="btn btn-md btn-primary generate-ws-fed-idp-metadata-button"
                                                    disabled={!this.props.applicationName || !this.props.userFriendlyName
                                                    || !this.props.redirectUri}
                                                    onClick={this.handleSaveSP}
                                                >
                                                    {messageConstants.WS_FED_GENERATE_METADATA}
                                                </button>
                                            )}
                                        </div>
                                    )
                                }
                                <WsFederationIdpMetadataPopup
                                    showModalWsFedIdpMetadata={this.props.showModalWsFedIdpMetadata}
                                    handleHideModalWsFedIdpMetadata={this.handleHideModalWsFedIdpMetadata}
                                    idpMetadata={this.props.idpMetadata}/>
                            </div>

                            <div className="action-row">
                                <button
                                    id="cancelSaveWsFedApplicationButton"
                                    type="button"
                                    className="btn btn-md cancel-save-button"
                                    onClick={this.handleAddWsFedCancel}
                                >
                                    {messageConstants.CANCEL}
                                </button>
                                &nbsp;
                                <button
                                    id="saveWsFedApplicationButton"
                                    type="button"
                                    className="btn btn-md btn-primary save-button"
                                    disabled={!this.props.applicationName || !this.props.userFriendlyName
                                        || !this.props.redirectUri || !applicationId}
                                    onClick={this.handleSaveSP}
                                >
                                    {messageConstants.SBA_SAVE_BUTTON}
                                </button>
                            </div>
                            <div>
                                <StartUsingNewIdpCertificateModal
                                    showModalStartUsingNewIdpCertificate={this.props.modalStartUsingNewIdpCertificateIsShown}
                                    handleHideModalStartUsingNewIdpCertificate={this.props.hideModalStartUsingNewIdpCertificate}
                                    handleStartUsingNewIdpCertificate={this.handleStartUsingNewIdpCertificate}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        errorMsg: state.sp.errorMsg,
        wsFederationProfile: state.sp.wsFederationProfile,
        redirectUri: state.sp.redirectUri,
        applicationId: state.sp.applicationId,
        applicationName: state.sp.applicationName,
        userFriendlyName: state.sp.userFriendlyName,
        idpMetadata: state.idp,
        showModalWsFedIdpMetadata: state.sp.showModalWsFedIdpMetadata,
        idpCertificateValidTo: state.idp.certificateValidTo,
        newIdpCertificateValidTo: state.idp.newCertificateValidTo,
        lastCertificateRotationDate: state.sp.lastCertificateRotationDate,
        modalStartUsingNewIdpCertificateIsShown: state.sp.modalStartUsingNewIdpCertificateIsShown,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAppName: (e) => {
            dispatch(spActions.updateAppName(e))
        },
        updateUserFriendlyName: (e) => {
            dispatch(spActions.updateUserFriendlyName(e))
        },
        addApp: (metadata) => {
            dispatch(spActions.addWsFed(metadata));
        },
        updateApp: (metadata) => {
            dispatch(spActions.updateApp(metadata));
        },
        cancelAddApp: () => {
            dispatch(spActions.cancelAddApp());
        },
        editAppId: (applicationId) => {
            dispatch(spActions.getApp(applicationId))
        },
        updateWsFedRedirectUri: (evt) => {
            dispatch(spActions.updateWsFedRedirectUri(evt));
        },
        clearMessages: () => {
            dispatch(spActions.clearMessages())
        },
        setErrorMessage: (errorMessage) => {
            dispatch(spActions.setErrorMessage(errorMessage))
        },
        getIdpMetadata: (applicationId) => {
            dispatch(idpActions.getIdpMetadata(applicationId));
        },
        showWsFedIdpMetadataPopup: () => {
            dispatch(spActions.showWsFedIdpMetadataPopup());
        },
        hideWsFedIdpMetadataPopup: () => {
            dispatch(spActions.hideWsFedIdpMetadataPopup());
        },
        openHelpDocPage: (url) => {
            dispatch(spActions.openHelpDocPage(url));
        },
        showModalStartUsingNewIdpCertificate: () => {
            dispatch(spActions.showModalStartUsingNewIdpCertificate())
        },
        hideModalStartUsingNewIdpCertificate: () => {
            dispatch(spActions.hideModalStartUsingNewIdpCertificate())
        },
        startUsingNewIdpCertificate: (applicationId) => {
            dispatch(spActions.startUsingNewIdpCertificate(applicationId))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WsFederationApp);



// WEBPACK FOOTER //
// ./src/components/WsFederationApp/index.js